import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import { postSurveyData } from '../../services/api';
import { setlocal, getlocal } from '../../../../../base/base/storage';

class MoreOption extends React.PureComponent {
    static propTypes = {
        surveyId: PropTypes.string,
        votecount: PropTypes.number,
        isExpire: PropTypes.bool,
        resultShow: PropTypes.bool,
        content: PropTypes.array,
        handleOptionSubmit: PropTypes.func,
        isSubmitSurvey: PropTypes.bool,
        isShowJoin: PropTypes.bool,
    };

    state = {
        surveyType: 0, // 调查类型 0 一个问题，单选，1 多个问题，均为单选，2 一个问题，多选 或者 多个问题，单选多选都有
        result: {},
        resultShowArr: [],
        votecount: this.props.votecount,
        submitType: 0, // 0 未选中，1 有选中但未提交，2 已提交
        isBtnShow: false,
        mustArr: [],
        currentMustArr: [],
        resultShow: this.props.resultShow,
        hasLocal: false,
        percentList: [],
    };

    componentWillReceiveProps() {
        this.handleLocalData('updata');
    }

    handleLocalData = (from) => {
        const { content } = this.props;
        const getlocalVal = getlocal('surveyResultData') || {};
        const result = {};
        const resultShowArr = [];

        content?.forEach((qestionItem) => {
            if (Object.keys(getlocalVal).includes(qestionItem.questionid)) {
                result[qestionItem.questionid] = getlocalVal[qestionItem.questionid];
                resultShowArr.push(qestionItem.questionid);
            }
        });

        if (resultShowArr.length === content.length) {
            this.setState({
                submitType: 2,
            });
        }

        if (from === 'didMount' && Object.keys(result).length > 0) {
            this.setState({
                hasLocal: true,
            });
        }

        this.setState({
            result,
            resultShowArr,
        });
    };

    componentDidMount() {
        const { isExpire, content } = this.props;

        this.handleLocalData('didMount');
        let surveyType = 0;
        let isBtnShow = false;

        if (content.length === 1) {
            // 一个问题
            if (content[0].choosetype === 'single') {
                // 单选
                surveyType = 0;
                isBtnShow = false;
            } else if (content[0].choosetype === 'multiple') {
                // 多选
                surveyType = 2;
                isBtnShow = true;
            }
        } else {
            // 多个问题
            let type = 'single';

            content.every((item) => {
                if (item.choosetype === 'multiple') {
                    type = 'multiple';

                    return false;
                }

                return true;
            });

            if (type === 'single') {
                // 全部都为单选
                surveyType = 1;
                isBtnShow = false;
            } else {
                // 单选，多选都有
                surveyType = 2;
                isBtnShow = true;
            }
        }

        if (isExpire) {
            isBtnShow = false;
        }

        const mustArr = content.filter((item) => item.ismust === '1').map((item) => item.questionid);

        this.setState({
            surveyType,
            isBtnShow,
            mustArr,
            percentList: this.percentListAttribute,
        });
    }

    handleSubmit = async (obj, resultObj, arr, canSubmit) => {
        const { surveyType, isBtnShow, submitType, currentMustArr } = this.state;
        const { surveyId, votecount, handleOptionSubmit } = this.props;

        // 未选择或已提交，不可提交
        if (!canSubmit && ((isBtnShow && submitType === 2) || submitType === 0)) return;

        if (currentMustArr.length > 0) {
            window.alert('有必选问题未投票！');

            return;
        }

        const str = Object.keys(obj).map((questionid) =>
            (obj[questionid] || []).map((itemid) => `sur[${questionid}][]=${itemid}`),
        );

        let newStr = [];

        str.forEach((item) => {
            newStr = newStr.concat(item);
        });

        let survey = {};

        try {
            survey = await postSurveyData(newStr.join('&'), surveyId);
        } catch (e) {
            console.error(e);
        }

        if (survey.ifsuccess === 1) {
            // 本地存储选中项目 begin
            const getlocalVal = getlocal('surveyResultData') || {};

            setlocal('surveyResultData', {
                ...getlocalVal,
                ...obj,
            });

            if (handleOptionSubmit) {
                handleOptionSubmit(surveyType);
            }
            // 本地存储选中项目 end

            this.setState(
                {
                    result: { ...resultObj },
                    resultShowArr: [...arr],
                    votecount: votecount + 1,
                    submitType: 2,
                    percentList: [],
                },
                () => {
                    setTimeout(() => {
                        this.setState({
                            percentList: this.percentListAttribute,
                        });
                    });

                    if (surveyType !== 1) {
                        window.alert(survey.msg);
                    }
                },
            );
        } else {
            if (survey?.msg.includes('未登录')) {
                window.alert('请前往客户端登录后参与投票');
            } else {
                window.alert(survey.msg);
            }

            // this.setState(
            //     {
            //         result: {},
            //         resultShowArr: [],
            //         resultShow: true,
            //         submitType: 2,
            //     },
            //     () => {
            //         window.alert(survey.msg);
            //     },
            // );
        }
    };

    handleClick = async (choosetype, questionid, itemid) => {
        const { surveyType, result, resultShowArr, mustArr } = this.state;
        const { content } = this.props;

        if (surveyType === 0) {
            // 一个问题，单选
            const obj = {
                [questionid]: [itemid],
            };

            const resultObj = obj;

            const arr = [questionid];

            this.handleSubmit(obj, resultObj, arr, true);
        } else if (surveyType === 1) {
            // 多个问题，均为单选
            const obj = {
                [questionid]: [itemid],
            };

            const resultObj = { ...result, ...obj };

            const arr = [...new Set([...resultShowArr, questionid])];

            this.handleSubmit(obj, resultObj, arr, true);
        } else if (surveyType === 2) {
            if (this.state.submitType === 2) return;

            const obj = { ...result };

            if (choosetype === 'single') {
                obj[questionid] = [itemid];
            } else {
                const arr = result[questionid] || [];

                if (arr.includes(itemid)) {
                    arr.splice(arr.indexOf(itemid), 1);
                } else {
                    arr.push(itemid);
                }

                obj[questionid] = [...arr];
            }

            let submitType = 0;

            let len = 0;

            for (const i of Object.keys(obj)) {
                if (obj[i].length > 0) {
                    len++;
                }
            }

            if (len === content.length) {
                submitType = 1;
            }

            const currentMustArr = [...mustArr];

            Object.keys(obj).forEach((item) => {
                if (currentMustArr.includes(item)) {
                    currentMustArr.splice(currentMustArr.indexOf(item), 1);
                }
            });

            this.setState({
                result: { ...obj },
                submitType,
                currentMustArr,
            });
        }
    };

    getPercent = (questionid, itemid, num, votecount, nump) => {
        const { result, hasLocal } = this.state;

        let newNum = num;

        let resultArr = Object.keys(result);

        if (resultArr.length !== 0 && result[questionid] && !hasLocal) {
            const newCount = votecount + result[questionid].length;

            if (this.getItemIds(questionid).includes(itemid)) {
                newNum = num + 1;
            }

            return (newNum * 100) / newCount;
        } else {
            return nump;
        }
    };

    formatPeopleCount = (count) => {
        if (count > 99999999) {
            return `${(count / 100000000).toFixed(1)}亿`;
        } else if (count > 9999) {
            return Number((count / 10000).toFixed(1)) === 10000 ? '9999.9万' : `${(count / 10000).toFixed(1)}万`;
        } else {
            return count;
        }
    };

    getItemIds = (questionid) => {
        const { result } = this.state;

        const itemIdArr = result[questionid] || [];

        return [...itemIdArr];
    };

    getSerNum = (content, index) => {
        if (content.length > 1) {
            return index > 9 ? `${index + 1}.` : `0${index + 1}.`;
        }

        return '';
    };

    percentListAttribute = [];

    widthTransitionHandle = (questionid, itemid, num, votecount, nump) => {
        const percent = Math.round(this.getPercent(questionid, itemid, num, votecount, nump));

        this.percentListAttribute.push(percent);
    };

    render() {
        const {
            result,
            resultShowArr,
            votecount,
            submitType,
            isBtnShow,
            resultShow,
            hasLocal,
            percentList,
        } = this.state;
        const { content, isExpire, isShowJoin } = this.props;

        let submitBtnStyle = styles.unSubmit_btn;

        if (submitType === 1) {
            submitBtnStyle = styles.activeSubmit_btn;
        } else if (submitType === 2) {
            submitBtnStyle = styles.submit_btn;
        }

        return (
            <>
                {content.map((option, index) => (
                    <div
                        className={index === content.length - 1 ? styles.option_last_box : styles.option_box}
                        key={index}>
                        <div className={styles.title}>
                            {`${this.getSerNum(content, index)}${option.question}${
                                option.ismust === '1' ? ' (此问必答)' : ''
                            }${option.choosetype === 'multiple' ? ' (多选)' : ''}`}
                        </div>
                        {resultShow || resultShowArr.includes(option.questionid) ? (
                            option.option.map((item, index) => (
                                <div key={index} className={styles.resultInner}>
                                    <div className={styles.spanOne}>{item.title}</div>
                                    {this.widthTransitionHandle(
                                        option.questionid,
                                        item.itemid,
                                        item.num,
                                        option.votecount,
                                        item.nump,
                                    )}
                                    <div
                                        className={
                                            this.getItemIds(option.questionid).includes(item.itemid)
                                                ? styles.check_bar
                                                : styles.bar
                                        }
                                        style={{
                                            width:
                                                isExpire || resultShow
                                                    ? `${item.nump}%`
                                                    : `${Math.round(
                                                          this.getPercent(
                                                              option.questionid,
                                                              item.itemid,
                                                              item.num,
                                                              option.votecount,
                                                              item.nump,
                                                          ),
                                                      )}%`,
                                        }}
                                    />
                                    <div
                                        className={`${styles.percentNumsOuter} ${
                                            this.getItemIds(option.questionid).includes(item.itemid)
                                                ? styles.checkColor
                                                : ''
                                        }`}>
                                        <div className={styles.percentNums}>
                                            {Math.round(
                                                this.getPercent(
                                                    option.questionid,
                                                    item.itemid,
                                                    item.num,
                                                    option.votecount,
                                                    item.nump,
                                                ),
                                            )}
                                            {'%'}
                                        </div>
                                        <div className={styles.check_num}>
                                            (
                                            {this.getItemIds(option.questionid).includes(item.itemid) && !hasLocal
                                                ? this.formatPeopleCount(item.num + 1)
                                                : this.formatPeopleCount(item.num)}
                                            {'人'})
                                        </div>
                                    </div>
                                </div>
                            ))
                        ) : (
                            <div className={styles.option}>
                                {option.option.map((item, index) => (
                                    <div
                                        key={index}
                                        onClick={() =>
                                            this.handleClick(option.choosetype, option.questionid, item.itemid)
                                        }
                                        className={`${styles.optionBox} ${
                                            this.getItemIds(option.questionid).includes(item.itemid) ? styles.check : ''
                                        }`}>
                                        <div className={styles.optionText}>{item.title}</div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                ))}
                {isBtnShow && (
                    <a
                        className={`${submitBtnStyle}`}
                        onClick={() => this.handleSubmit(result, result, Object.keys(result))}>
                        <span>{submitType === 2 ? '已提交' : '确认提交'}</span>
                    </a>
                )}
                {isShowJoin && (
                    <div className={styles.tips}>
                        <span>{`${votecount}人参与`}</span>
                        <span>{isExpire ? '抱歉，本调查已经结束' : '投票进行中'}</span>
                    </div>
                )}
            </>
        );
    }
}

export default MoreOption;
